<div class="bg-white" *ngIf="isUserLoggedIn; else loggedOut">
  <app-loading-general></app-loading-general>
  <app-shopping-cart-sidebar></app-shopping-cart-sidebar>
  <app-navbar></app-navbar>
  <app-footer></app-footer>
</div>

<ng-template #loggedOut>
  <router-outlet></router-outlet>
</ng-template>
